import React from 'react'

const Container = ({ className, children }) => {
  return (
    <div className={`w-full px-4 md:px-0 md:mx-auto md:w-11/12 flex-1 ${className ? className : ''}`}>{children}</div>
  )
}

export default Container